<template>
  <div class="footer">
    <div class="container">
      <el-row style="margin-bottom: 15px;">
        <el-col :span="6">
          <div class="title">关于</div>
          <ul>
            <li><a href="https://www.tangyuanjizhang.com/update_log.html" target="_blank">更新日志</a></li>
            <li><a href="https://www.tangyuanjizhang.com/user_agreement.html" target="_blank">用户条款</a></li>
            <li><a href="https://www.tangyuanjizhang.com/privacy_policy.html" target="_blank">隐私条款</a></li>
          </ul>
        </el-col>
        <el-col :span="6">
          <div class="title">帮助与反馈</div>
          <ul>
            <li><a href="https://www.tangyuanjizhang.com/help.html" target="_blank">帮助文档</a></li>
            <li><a href="mailto:feedback@tangyuanjizhang.com" target="_blank">反馈或吐槽</a></li>
          </ul>
        </el-col>
        <el-col :span="6">
          <div class="title">联系我们</div>
          <ul>
            <!-- <li><a href="javascript:void(0)">新浪微博</a></li> -->
            <li><a href="javascript:void(0)">微信公众号</a></li>
          </ul>
        </el-col>
        <el-col :span="6">
          <div style="width: 100px; height: 120px">
            <img class="qrcode" src="../assets/qrcode_for_gh_fa109cc0270a_258.jpg" alt="Android版下载">
            <div style="text-align: center;">微信扫一扫</div>
          </div>
        </el-col>
      </el-row>
      <div class="address">© 2020 上海煜宿信息技术有限公司 地址:上海市奉贤区肖塘路255弄10号1层 &nbsp;&nbsp;&nbsp;
      <a class="qualification" href="http://beian.miit.gov.cn/" target="_blank">沪ICP备20015532号</a> &nbsp;&nbsp;&nbsp;
      <a class="qualification" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31012002005347">
      <img style="position:relative;top:5px;margin-right:2px;" src="../assets/gongan.png" alt="公安备案">
      沪公网安备31012002005347号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/public.scss';

.footer {
	position:relative;
	width: 100%;
	font-size: 12px;
	border-top: 1px solid $color-split-line;
	width: 100%;
  padding: 20px 0px;
  background: $color-board;
  
  .title {
    margin-top: 10px;
    margin-bottom: 5px;
    color: #999999;
  }

  ul {
    padding: 0px;
    list-style-type: none;
    line-height: 24px;
  }

  a {
    display: inline;
    color: #000000;
    text-decoration: none;

    &:active, &:hover {
      text-decoration: underline;
    }
  }

  .qualification {
    margin-left: 10px;

  }

  .qrcode {
    margin-top: 10px;
    width: 120px;
  }

  .address {
    margin-top: 40px;
    text-align: left;
  }
}
</style>